(function () {
    'use strict';
    var m = angular.module('devices', []);
}());